var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawDeepThinkerAvatar6Xg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-631"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(980 239)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(33 -100)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-947 -339)",
    clipPath: "url(#a-631)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-433.976 85.328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1058.619,314.491l-6.877,33.775-33.668,56.586-41.521-17.734S920.135,328,955.587,319.553a31.091,31.091,0,0,0,11.772-5.245c6.968-5.245,9.149-12.885,9.149-20.356,0-12.336-5.764-24.229-5.764-24.229l72.627-22.872a116,116,0,0,0-5.215,29.429c-.549,19.823,6.8,29.52,12.824,34.171a22.021,22.021,0,0,0,7.64,4.041Z",
    transform: "translate(740.266 176.516)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1054.149,260.58a57.181,57.181,0,1,1-16.72-40.665A57.425,57.425,0,0,1,1054.149,260.58Z",
    transform: "translate(737.859 153.576)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.181,348.1s-29.7-41.17-18.511-57.165l-50.182,20.57s-30.207-3.66-41.17,41.414a77.964,77.964,0,0,0-1.876,22.872c.4,6.8-.518,18.771-8.264,34.247-12.4,24.778-9.576,81.639,15.767,87.28s34.339,2.806,34.339,2.806-3.37,103.047-18.008,114.864S965.588,624,965.588,624s44.891,2.257,67.976,5.627,87.829-11.817,87.829-11.817-9.576-43.366-12.946-70.95-11.268-86.335-11.268-86.335l57.44-77.766s10.125-47.01-25.342-67.839S1080.482,289,1080.482,289s-35.589,57.943-54.161,60.794C1026.321,349.794,1019.261,352.631,1016.181,348.1Z",
    transform: "translate(711.48 198.637)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.516,338.47s-.564,18.587,2.806,25.922,15.767,47.864,15.767,47.864H922.94s15.248-16.331,14.074-24.214S932.516,338.47,932.516,338.47Z",
    transform: "translate(729.273 224.6)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.766,457.584s-62.182-15.248-67.976-28.163S925,387.5,925,387.5l6.557-8.844L961.809,402.4s36.031,28.712,52.926,31.533S1014.766,457.584,1014.766,457.584Z",
    transform: "translate(730.354 245.692)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.766,457.584s-62.182-15.248-67.976-28.163S925,387.5,925,387.5l6.557-8.844L961.809,402.4s36.031,28.712,52.926,31.533S1014.766,457.584,1014.766,457.584Z",
    transform: "translate(730.354 245.692)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1057.793,382.519v33.729h-5.428a157.85,157.85,0,0,0-76.534,19.808l-10.182,5.657-2.729,1.525-17.459-39.31,16.331-14.638h.839c3.995.381,21.271,1.83,28.59-.64,6.953-2.363,15.584-9.85,36.062-4.574,10.094,2.577,18.709,13.891,28.5,10.354Z",
    transform: "translate(741.091 247.566)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.089,355.356l11.268,12.656v30.695s-9.545,96.841-40.042,107.545-84.688-6.206-84.688-6.206-14.013-37.16-7.456-39.4,57.943-15.828,57.943-15.828-.732-56.815,10.536-73.71c0,0-7.319-52.911,18.023-54.039S1098.089,355.356,1098.089,355.356Z",
    transform: "translate(756.817 213.355)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960.79,337.55l17.627,72.429S992.323,409.9,960.79,337.55Z",
    transform: "translate(749.137 224.117)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.862,329.61s-23.086,37.815-14.074,76.9l4.3.32S988.4,388.727,1005.862,329.61Z",
    transform: "translate(764.31 219.95)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.433,386.85s-5.627,39.4,4.574,55.168c0,0-20.616,8.447-49.557,6.755l-19.7-61.923Z",
    transform: "translate(724.45 249.99)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.363,249.976c-6.68.87-11.719-5.966-14.055-12.283s-4.116-13.673-9.924-17.086c-7.934-4.662-18.085.945-27.158-.593-10.254-1.738-16.91-12.6-17.434-22.974s3.609-20.362,7.661-29.933l1.415,11.9a23.586,23.586,0,0,1,10.305-20.616l-1.816,17.45a18.523,18.523,0,0,1,21.306-15.335l-.287,10.4c11.836-1.408,23.773-2.816,35.642-1.745s23.822,4.827,32.818,12.645c13.457,11.693,18.371,30.945,16.723,48.707s-8.972,34.424-16.615,50.538c-1.921,4.054-4.578,8.626-9.034,9.143-4,.463-7.667-2.882-8.912-6.72a24.338,24.338,0,0,1,.108-11.959c1.126-5.984,2.543-12.1,1.487-18.093s-5.372-11.92-11.415-12.655-12.228,6.174-9.322,11.523Z",
    transform: "translate(1186.412 171.578)",
    fill: "#090814"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDeepThinkerAvatar6Xg6);
export default __webpack_public_path__ + "static/media/undraw_deep-thinker-avatar_6xg6.3d77f30060651ad3880dd2a23c90f22f.svg";
export { ForwardRef as ReactComponent };